// ICONS
import HappyMapPointerIcon from '@stencil/icons/src/HappyMapPointerIcon/HappyMapPointerIcon';

// STYLES
import * as S from '../HomePageAutosuggest/HomePageAutosuggest.styles';

const AutoSuggestPopularLocation = ({getItemProps, selectedItem, popularDestinations = []}) => {
  // Return null if there are no popular destinations
  if (!popularDestinations?.length) return null;

  return popularDestinations.map((item, index) => {
    const key = `${item.voyId || ''}-${item.name || ''}-${index}`;
    const itemProps = getItemProps({
      item,
      index,
      isSelected: selectedItem === item,
    });

    return (
      <S.FswAutoCompItemOuter key={key}>
        {index === 0 && <S.PopularSearchesHeading>Popular Searches</S.PopularSearchesHeading>}
        <S.FswAutoCompItem {...itemProps}>
          <S.FswAutoCompItemLeft>
            <S.FswAutoCompItemImg>
              <HappyMapPointerIcon fill={'#B0B0B0'} height={'2.1rem'} width={'2.1rem'} />
            </S.FswAutoCompItemImg>
            <S.FswAutoCompItemDescWrapper>
              <S.FswAutoCompItemDesc>
                <S.FswAutoCompItemDescTitle>{item.displayName}</S.FswAutoCompItemDescTitle>
              </S.FswAutoCompItemDesc>
            </S.FswAutoCompItemDescWrapper>
          </S.FswAutoCompItemLeft>
          <S.FswAutoCompItemRight />
        </S.FswAutoCompItem>
      </S.FswAutoCompItemOuter>
    );
  });
};

export default AutoSuggestPopularLocation;
